module.exports = __webpack_public_path__ + "static/media/icon_generic.8ffce78c.svg";